import { apiSlice } from './apiSlice';

export const stripeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStripeConfig: builder.query({
      query: () => ({
        url: '/api/stripe/config',
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
    }),
    createStripePaymentIntent: builder.mutation({
      query: (orderId) => ({
        url: `/api/stripe/create-payment-intent/${orderId}`,
        method: 'POST',
      }),
    }),
    createStripeUpgradePaymentIntent: builder.mutation({
      query: () => ({
        url: '/api/stripe/create-upgrade-payment-intent',
        method: 'POST',
      }),
    }),
    confirmStripeUpgradePayment: builder.mutation({
      query: (paymentIntentId) => ({
        url: '/api/stripe/confirm-upgrade-payment',
        method: 'POST',
        body: { paymentIntentId },
      }),
    }),
  }),
});

export const {
  useGetStripeConfigQuery,
  useCreateStripePaymentIntentMutation,
  useCreateStripeUpgradePaymentIntentMutation,
  useConfirmStripeUpgradePaymentMutation,
} = stripeApiSlice;
